<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path d="M26 35L13.2374 22.2374C12.554 21.554 12.554 20.446 13.2374 19.7626L26 7" stroke="white" stroke-width="3.5" stroke-linecap="round"/>
    </svg>
</template>